import React from 'react';
import '../../App.css';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../styles/theme.js';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import SecondaryButton from '../../components/common/secondaryButton';

import Carousel01 from '../../assets/images/carousel/carousel-01.png';
import Carousel02 from '../../assets/images/carousel/carousel-02.png';
import Carousel03 from '../../assets/images/carousel/carousel-03.png';
import Carousel04 from '../../assets/images/carousel/carousel-04.png';
import GooglePlay from '../../assets/images/logos/google-play.png';
import AppleStore from '../../assets/images/logos/apple-store.png';
import PrimaryCarousel from '../common/PrimaryCarousel';
import NeritoOurApp from '../../assets/images/NeritoOurApp2.svg';

const OurCarousel = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.rowContainer}>
      
      <div className={classes.halfContainer}>
        <div className={classes.textContainer}>
          <div>
            <img src={NeritoOurApp} className={classes.imgContainer} />
          </div>
            <Typography className={classes.blackTitle}>Descarga Nerito App</Typography>
            <div className={classes.downloadButtonsContainer}>
              <a href="https://play.google.com/store/apps/details?id=com.nerito.wallet" target="_blank" rel="noopener noreferrer">
                <img
                  src={GooglePlay}
                  alt='Google Play Store'
                  style={{ width: '150px', marginRight: '10px' }}
                />
              </a>

              <a href="https://apps.apple.com/us/app/nerito/id1551319508" target="_blank" rel="noopener noreferrer">
                <img
                  src={AppleStore}
                  alt='Apple Store'
                  style={{ width: '150px', marginRight: '10px' }}
                />
              </a>
            </div>
        </div>
      </div>

      <div className={classes.halfContainer}>
        <PrimaryCarousel
          data = {[Carousel01,Carousel02,Carousel03,Carousel04]}
        />
      </div>

    </div>
  )
}

export default OurCarousel;

const useStyles = makeStyles({
  greenTitle: {
    fontFamily: 'Montserrat',
    fontWeight: '700',
    fontSize: 60,
    textAlign: 'center',
    color: theme.palette.primary.main,
    padding: 0,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      fontSize: 40
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 35,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
    },
  },
  blackTitle: {
    fontFamily: 'Montserrat',
    fontWeight: '700',
    fontSize: 40,
    textAlign: 'center',
    color: theme.palette.green.main,
    padding: 0,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      fontSize: 30
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // justifyContent: 'center',
    width: '80%',
    height: '100%',
    padding: 50,
    textAlign: 'justify',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      padding: 30,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: 10,
    },
  },
  halfContainer: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontWeight: '600',
    fontSize: '24px',
  },
  carousel: {
    display: 'flex',
    justifyContent: 'center'
  },
  imgContainer: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  downloadButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '70%',
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  
});